/**
 * Le Risonanze sono le "frequenze" elementali con cui i Lumini si sintonizzano
 * alle anomalie magnetiche del pianeta Lumen. Sei frequenze, due triadi:
 *
 *   Triade del Calore:  BRACE → ECO → MAREA → BRACE
 *   Triade del Campo:   AURORA → VOLT → TERRA → AURORA
 *
 * (la freccia indica "è efficace contro"; l'inverso è poco efficace)
 */

export type Risonanza = 'aurora' | 'brace' | 'marea' | 'terra' | 'volt' | 'eco';

export const RISONANZE: readonly Risonanza[] = ['aurora', 'brace', 'marea', 'terra', 'volt', 'eco'];

export const RISONANZA_LABEL: Record<Risonanza, string> = {
  aurora: 'Aurora',
  brace: 'Brace',
  marea: 'Marea',
  terra: 'Terra',
  volt: 'Volt',
  eco: 'Eco',
};

export const RISONANZA_COLOR: Record<Risonanza, string> = {
  aurora: '#9ad7f5',
  brace: '#f5a26b',
  marea: '#6bb8e8',
  terra: '#c9a06b',
  volt: '#f5e06b',
  eco: '#c39af5',
};

const SUPER = 2;
const WEAK = 0.5;

const ADVANTAGE: Record<Risonanza, Risonanza> = {
  brace: 'eco',
  eco: 'marea',
  marea: 'brace',
  aurora: 'volt',
  volt: 'terra',
  terra: 'aurora',
};

/** Moltiplicatore di efficacia di una mossa `attacker` contro un Lumine `defender`. */
export function effectiveness(attacker: Risonanza, defender: Risonanza): number {
  if (ADVANTAGE[attacker] === defender) return SUPER;
  if (ADVANTAGE[defender] === attacker) return WEAK;
  return 1;
}
